import ReactGA from 'react-ga4';

export const trackEvent = (data: { action: string; category: string; label: string }) => {
  ReactGA.event({
    action: data.action,
    category: `${process.env.REACT_APP_ENV}-${data.category}`,
    label: data.label
  });
};
